export default __webpack_public_path__ + "static/media/sg.ec21683c.jpg";